import { getCustomerIdentifier } from "@/lib/api";
import { getDiscountCode } from "@/lib/emailStorage";

/**
 * Stable string for "who is shopping" + active URL discount code.
 * Used to invalidate local cart when either changes.
 */
export function getCartIdentityFingerprint(): string {
  const id = getCustomerIdentifier();
  const discount = getDiscountCode();
  const customerPart =
    id == null
      ? "none"
      : id.type === "id"
        ? `id:${id.shopify_customer_id}`
        : `token:${id.buy_again_token}`;
  const discountPart = discount ?? "";
  return `${customerPart}|${discountPart}`;
}
